import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconChevronRight = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="circle-chevron-right-solid 1" clipPath="url(#clip0_19351_30573)">
                <path id="Vector" d="M0 10.5C0 13.1522 1.05357 15.6957 2.92893 17.5711C4.8043 19.4464 7.34784 20.5 10 20.5C12.6522 20.5 15.1957 19.4464 17.0711 17.5711C18.9464 15.6957 20 13.1522 20 10.5C20 7.84784 18.9464 5.3043 17.0711 3.42893C15.1957 1.55357 12.6522 0.5 10 0.5C7.34784 0.5 4.8043 1.55357 2.92893 3.42893C1.05357 5.3043 0 7.84784 0 10.5ZM9.41406 15.2266C9.04688 15.5938 8.45312 15.5938 8.08984 15.2266C7.72656 14.8594 7.72266 14.2656 8.08984 13.9023L11.4883 10.5039L8.08984 7.10547C7.72266 6.73828 7.72266 6.14453 8.08984 5.78125C8.45703 5.41797 9.05078 5.41406 9.41406 5.78125L13.4766 9.83594C13.8438 10.2031 13.8438 10.7969 13.4766 11.1602L9.41406 15.2266Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_19351_30573">
                    <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconChevronRight;
